<template>
  <form
    :id="id"
    :class="{ 'no-gutters': noGutters }"
    autocomplete="off"
    @submit.prevent="validate()"
    :data-vv-scope="scope"
  >
    <slot></slot>
  </form>
</template>

<script>
import { EventsGlobal } from "~/events/eventsGlobal";

export default {
  inject: ["$validator"],
  name: "form-validator",
  props: {
    id: String,
    noGutters: {
      type: Boolean
    },
    scope: String
  },
  methods: {
    focusFirstError() {
      this.$nextTick(() => {
        if (this.errors.any()) {
          let firstError = this.errors.items[0];
          const errorFirstElement = document.querySelector(
            `[name="${firstError.field}"]`
          );

          errorFirstElement.dispatchEvent(new Event("focus"));
          errorFirstElement.focus();
          errorFirstElement.scrollIntoView({ behavior: "smooth" });
        }
      });
    },
    validate() {
      return this.$validator
        .validateAll(this.scope)
        .then(success => {
          if (!success) this.focusFirstError();
          return success;
        })
        .catch(err => {
          this.$raven.captureException(err);

          console.log(err);
        });
    }
  },
  created() {
    EventsGlobal.$on("onEnter", results => {
      this.$emit("onSubmit", true);
    });
  }
};
</script>

<style>
/* Forms */

@-webkit-keyframes autofill {
  to {
    color: #555;
    background: transparent;
  }
}

input:-webkit-autofill {
  -webkit-animation-name: autofill;
  -webkit-animation-fill-mode: both;
}

.no-gutters .row {
  padding-left: 10px;
  padding-right: 10px;
}

.no-gutters .row > .col,
.no-gutters .row > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.no-gutters .form-group {
  position: relative;
  height: 100%;
  border: 1px solid #ced4da;
  padding: 10px 15px;
  margin-right: -1px;
  margin-bottom: -1px;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
}

.no-gutters .form-group-active {
  background-color: #f8f9fa;
}

.no-gutters .form-group small {
  display: none;
}

.icon-error {
  display: none;
}

.no-gutters .icon-error {
  position: absolute;
  right: 22px;
  bottom: 22px;
  color: #a94442;
  cursor: help;
  display: block;
}

.no-gutters .has-error .help-block,
.no-gutters .has-error .control-label,
.no-gutters .has-error .radio,
.no-gutters .has-error .checkbox,
.no-gutters .has-error .radio-inline,
.no-gutters .has-error .checkbox-inline {
  color: #a94442;
}

.no-gutters .has-error .form-control {
  color: #a94442;
}

.no-gutters .form-control {
  border: none;
  padding-left: 0px;
  padding-right: 0px;
  font-weight: normal !important;
  background-color: transparent;
  font-family: "Roboto", Helvetica, sans-serif !important;
  font-weight: 700 !important;
}

.no-gutters select.form-control {
  margin-left: -4px;
  padding-left: 0px;
  padding-right: 0px;
  height: 38px;
}

.no-gutters select.form-control > option {
  font-family: "Roboto", Helvetica, sans-serif !important;
}

.no-gutters .control-label {
  text-transform: uppercase;
  font-size: 11px;
  color: #868ba1;
  margin-bottom: 0px !important;
}

.no-gutters .form-control:focus {
  border: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.no-gutters .form-control:disabled,
.no-gutters .form-control[readonly] {
  background-color: transparent;
}
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormValidator.vue